import EllipsisVerticalToggle from "../Dropdowns/EllipsisVerticalToggle";
import { Dropdown } from "react-bootstrap";
import { faTrash, faPen, faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const priorityConfig = {
  Highest:    { color: "#c62828", bg: "#ffebee", label: "Highest" },
  High:       { color: "#e65100", bg: "#fff3e0", label: "High" },
  Normal:     { color: "#2e7d32", bg: "#e8f5e9", label: "Normal" },
  Low:        { color: "#1565c0", bg: "#e3f2fd", label: "Low" },
  Nicetohave: { color: "#616161", bg: "#f5f5f5", label: "Nice to have" },
};

const KanbanCard = ({
  index,
  action,
  setEditAction,
  setShowForm,
  setViewAction,
  deleteData,
  setDataList,
  dataList,
}) => {
  const p = priorityConfig[action.priority] || priorityConfig.Nicetohave;

  return (
    <div
      onClick={() => { setEditAction(action); setShowForm(true); }}
      style={{
        background: "#fff",
        borderRadius: "10px",
        boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
        borderLeft: `4px solid ${p.color}`,
        padding: "12px 14px",
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        cursor: "pointer",
        transition: "box-shadow 0.15s",
      }}
      onMouseEnter={(e) => { e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.13)"; }}
      onMouseLeave={(e) => { e.currentTarget.style.boxShadow = "0 1px 6px rgba(0,0,0,0.08)"; }}
    >
      {/* Title row */}
      <div style={{ display: "flex", alignItems: "flex-start", gap: "8px" }}>
        <span style={{ flex: 1, fontWeight: 600, fontSize: "0.9rem", color: "#212121", lineHeight: 1.3 }}>
          {action.title}
        </span>
        <Dropdown style={{ flexShrink: 0 }} onClick={(e) => e.stopPropagation()}>
          <EllipsisVerticalToggle />
          <Dropdown.Menu style={{
            borderRadius: "10px",
            border: "none",
            boxShadow: "0 8px 24px rgba(0,0,0,0.12)",
            padding: "6px",
            minWidth: "140px",
          }}>
            <Dropdown.Item
              onClick={() => setViewAction(action)}
              style={{ borderRadius: "6px", fontSize: "0.85rem", padding: "8px 12px", display: "flex", alignItems: "center", gap: "8px", color: "#424242" }}
            >
              <FontAwesomeIcon icon={faEye} style={{ color: "#1a73e8", width: "14px" }} /> View
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => { setEditAction(action); setShowForm(true); }}
              style={{ borderRadius: "6px", fontSize: "0.85rem", padding: "8px 12px", display: "flex", alignItems: "center", gap: "8px", color: "#424242" }}
            >
              <FontAwesomeIcon icon={faPen} style={{ color: "#f57c00", width: "14px" }} /> Edit
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => deleteData(action.id, index, setDataList, dataList)}
              style={{ borderRadius: "6px", fontSize: "0.85rem", padding: "8px 12px", display: "flex", alignItems: "center", gap: "8px", color: "#c62828" }}
            >
              <FontAwesomeIcon icon={faTrash} style={{ width: "14px" }} /> Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>

      {/* Description */}
      {action.beschreibung && (
        <p style={{ margin: 0, fontSize: "0.8rem", color: "#757575", lineHeight: 1.4 }}>
          {action.beschreibung}
        </p>
      )}

      {/* Footer: priority + tags */}
      <div style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "6px", marginTop: "2px" }}>
        <span style={{
          background: p.bg,
          color: p.color,
          fontSize: "0.7rem",
          fontWeight: 700,
          padding: "2px 8px",
          borderRadius: "20px",
        }}>
          {p.label}
        </span>
        {action.tags && action.tags.map((tag) => (
          <span key={tag.id} style={{
            background: "#e8f5e9",
            color: "#2e7d32",
            fontSize: "0.7rem",
            fontWeight: 600,
            padding: "2px 8px",
            borderRadius: "20px",
          }}>
            {tag.name}
          </span>
        ))}
      </div>
    </div>
  );
};

export default KanbanCard;
